import React, {useEffect, useState} from 'react'
import moment from 'moment'
import {Row, Col} from 'react-bootstrap'

import Page from '../../../component/Page/Page'
import BreadcrumbItem from '../../../component/BreadcrumbItem/BreadcrumbItem'
import {TransactionTable} from '../../../component/Table/TransactionTable'
import {PortalCustomHeader} from "../PortalCustomHeader/PortalCustomHeader"
import {TransanctionStatusContainer} from '../../../component/Transaction/TransactionStatusContainer'
import {ButtonPortal} from '../../../component/Button/ButtonPortalItem'
import {TransactionControl} from '../../../component/Transaction/TransactionControl'
import WebSocketTon, {Notificationtype} from "../../../utils/WebSocket";
import UserService from "../../../services/UserService";
import PortalService from "../PortalService";
import Notify from "../../../services/Notify";
import {InfinityLoading} from '../../../component/Loading/InfinityLoading'
import {dayMonthYearAtTimeWithSeconds} from "../../../utils/dates";
import ReadpointService from "../../../services/ReadpointService";
import {ModalMessage} from '../../../component/Modal/ModalMessage'
import ReasonCancelTransactionModal from '../../../component/Modal/ReasonCancelTransactionModal'
import { ModalWithGrid } from '../../../component/Modal/ModalWithGrid'
import PortalTransactionsEpcGrid from '../../../customGrid/entities/PortalTransactionsEpcGrid'
import TransactionItemService from '../../../services/TransactionItemsService'
import WrongWorkFlowGridDetailType from '../../Alerts/CustomAlert/WrongWorkFlow/WrongWorkFlowGridDetailType'
import LoadingV2 from '../../../component/Loading/LoadingV2'

const portalService = new PortalService();
const readpointService = new ReadpointService()
const transactionItemService = new TransactionItemService()

export const TransactionPortalPage = ({match, history, location}) => {

  const [readpoint, setReadpoint] = useState({id: match.params.readpointId});
  const [transaction, setTransaction] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(null)
  const [modalActionType, setModalActionType] = useState(null)
  const [allWrongWorkFlowModal, setAllWrongWorkFlowModal] = useState(false)
  const [hasWrongWorkflow, setHasWrongWorkflow] = useState(false)

  const modalEpcGrid = new WrongWorkFlowGridDetailType(hasWrongWorkflow)

  useEffect(() => {

    let subscriptionTransaction = null;
    let subscriptionTransactionTarget = null;
    let subscriptionWrongWorkFlow = null;
    let transactionData = [];

    const onMessageInWebSocket = ({type, payload}) => {

      if (Notificationtype.SAVE_TRANSACTION === type) {
        const dataPayload = JSON.parse(payload.json);
        if (dataPayload.id === transactionData.id) {
          setTransaction(dataPayload);
        }
      }
    }

    const onCloseTransaction = ({type, payload}) => {
      const data = JSON.parse(payload.data);

      if (transactionData.id === data.transaction.id) {
        if (Notificationtype.CLOSE_TRANSACTION_TARGET === type) {
          Notify.success('Transação Finalizada')
          history.push('/portals')
        }
      }
    }

    const onWrongWorkFlow = ({payload}) => {
      const { transactionId, productType } = payload.json && JSON.parse(payload.json);

      if (transactionData.id === transactionId) {
        setHasWrongWorkflow(true)
        Notify.warning(`${productType.reference} - ${productType.friendlyName} está com problema de WorkFlow`)
      }
    }

    const subscribeInWS = async () => {
      subscriptionTransaction = await WebSocketTon.getInstance().subscribe(`/topic/companies/${UserService.getCompanyId()}/save/transaction`, onMessageInWebSocket);
      subscriptionTransactionTarget = await WebSocketTon.getInstance().subscribe(`/topic/companies/${UserService.getCompanyId()}/transactiontarget`, onCloseTransaction)
      subscriptionWrongWorkFlow = await WebSocketTon.getInstance().subscribe(`/topic/companies/${UserService.getCompanyId()}/workflow/transaction/items`, onWrongWorkFlow)
    }

    async function loadTransactionData() {
      const data = await portalService.getTransaction(readpoint.id);
      setTransaction(data);
      transactionData = data;
    }

    loadTransactionData();
    subscribeInWS();

    return () => {
      subscriptionTransactionTarget && subscriptionTransactionTarget.unsubscribe();
      subscriptionTransaction && subscriptionTransaction.unsubscribe();
      subscriptionWrongWorkFlow && subscriptionWrongWorkFlow.unsubscribe();
    }
  }, []
  );

  useEffect(() => {
    async function loadReadpoint() {
      const data = await readpointService.getReadPointById(match.params.readpointId);
      setReadpoint(data);
    }

    loadReadpoint()
  }, []);

  useEffect(() => {
    async function verifyWrongWorkflow() {
      const { hasProblem } = await transactionItemService.getAllItemsWithWrongWorkflow(transaction.id)
      setHasWrongWorkflow(hasProblem)
    }

    if (transaction && transaction.id) {
      verifyWrongWorkflow()
    }
  }, [transaction])

  const onPause = async () => {
    try {
      await portalService.pauseOperation(readpoint.id);
      Notify.success('Transação foi pausada!');
      history.push('/portals');
    } catch (e) {
      Notify.error('Falha ao pausar: ', e);
    }

    setIsLoading(false);
  }

  const onFinalize = async () => {
    try {
      setIsLoading(true);
      await portalService.finalizeOperation(readpoint.id);
      Notify.success('Transação na fila para processamento!');
      history.push('/portals');
    } catch (e) {
      Notify.error('Falha ao finalizar: ', e);
      setIsLoading(false);
    }
    setIsLoading(false);
  }

  const getLastReadDate = () => {
    let lastRead

    transaction && transaction.items.forEach(x => {
      if (!lastRead) {
        return lastRead = x.lastReadDate
      }

      if (moment(lastRead).isSameOrBefore(x.lastReadDate)) {
        lastRead = x.lastReadDate
      }
    })

    return lastRead && dayMonthYearAtTimeWithSeconds(lastRead)
  }

  const headerCustom = <PortalCustomHeader hasWrongWorkflow={hasWrongWorkflow} readpoint={readpoint} transaction={transaction} activeBell={() => setAllWrongWorkFlowModal(!allWrongWorkFlowModal)}/>

  const canPause = !(transaction && transaction.movementOrder);

  const MODAL_ACTION_TYPES = {
    'PAUSE': 'pause',
    'FINALIZE': 'finalize'
  }

  return (
    <Page
      headerCustom={headerCustom}
      breadcrumbs={[
        <BreadcrumbItem key={1} title="Portais" to="/portals"/>,
        <BreadcrumbItem key={2} title="Operação"/>
      ]}>
      <LoadingV2 isLoading={!transaction}>
        <Row className="align-items-center justify-content-around mb-5">
          <Col md={8}>
            <TransanctionStatusContainer transactionData={transaction} bizLocation={location.state && location.state.bizLocation && location.state.bizLocation.friendlyName}/>
          </Col>
          <Col md={3}>
            <TransactionControl
              isLoading={isLoading}
              buttons={[
                <ButtonPortal text="Cancelar" icon="ban fa-lg" style={styles.cancelButton} onClick={() => setShowCancelModal(true)}/>,
                <ButtonPortal disabled={canPause} text="Pausar" icon="pause-circle fa-lg" style={styles.pauseButton} onClick={() => {
                  setShowModal(true)
                  setModalActionType(MODAL_ACTION_TYPES.PAUSE)
                }}/>,
                <ButtonPortal text="Finalizar" icon="stop-circle fa-lg" style={styles.stopButton} onClick={() => {
                  setShowModal(true)
                  setModalActionType(MODAL_ACTION_TYPES.FINALIZE)
                }}/>
              ]}
              lastRead={getLastReadDate() || ""}
              transaction={transaction}
            />
          </Col>
        </Row>
        <Row className="d-flex flex-column justify-content-center">
          <Col md={12}>
            <InfinityLoading/>
          </Col>
          <Col md={12}>
            <TransactionTable transaction={transaction} readpointId={readpoint.id}/>
          </Col>
        </Row>
        <ModalWithGrid
          title="Todos os produtos com workflow incorreto"
          match={match}
          showModal={allWrongWorkFlowModal} 
          handleShowModal={() => setAllWrongWorkFlowModal(!allWrongWorkFlowModal)} 
          metadata={modalEpcGrid}
          addParams={params => {
            params.append('active', true)
          }}
          endpoint={modalEpcGrid.endpoint(transaction && transaction.id)}
        />
        <ModalMessage
          showModal={showModal}
          handleShowModal={setShowModal}
          successButtonAction={modalActionType === MODAL_ACTION_TYPES.FINALIZE ? onFinalize : onPause}
          title="Tem certeza que deseja realizar esta operação ?"
        />
        <ReasonCancelTransactionModal 
          showModal={showCancelModal}
          handleShowModal={setShowCancelModal}
          readpointId={readpoint.id}
        />
      </LoadingV2>
    </Page>
  )
}

const styles = {
  pauseButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#34AFF9',
    boxShadow: '0px 8px 16px rgba(52, 175, 249, 0.2)',
    borderRadius: '4px',
    height: 40,
    width: 90,
    border: 'none',
    fontWeight: '600',
    textAlign: 'center',
    color: 'white',
  },
  stopButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#885AF8',
    boxShadow: '0px 8px 16px rgba(52, 175, 249, 0.2)',
    borderRadius: '4px',
    height: 40,
    width: 90,
    border: 'none',
    fontWeight: '600',
    textAlign: 'center',
    color: 'white',
  },
  cancelButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ff6961',
    boxShadow: '0px 8px 16px rgba(52, 175, 249, 0.2)',
    borderRadius: '4px',
    height: 40,
    width: 90,
    border: 'none',
    fontWeight: '600',
    textAlign: 'center',
    color: 'white',
  }
}



// WEBPACK FOOTER //
// ./src/pages/PortalPage/Transaction/TransactionPortalPage.js